export class RiskRequest {
  constructor(
    public documentType: number,
    public documentNumber: string,
    public firstSurname: string,
    public secondSurname: string,
    public firstName: string,
    public secondName: string,
    public idApplication: number,
    public usernameRisk: string,
    public passwordRisk: string,
    public personType: number,
    public idBranchOffice: number,
    public idMovement: number,
    public validationMode: number
  ) {
    this.documentType = documentType;
    this.documentNumber = documentNumber;
    this.firstSurname = firstSurname;
    this.secondSurname = secondSurname;
    this.firstName = firstName;
    this.secondName = secondName;
    this.idApplication = idApplication;
    this.usernameRisk = usernameRisk;
    this.passwordRisk = passwordRisk;
    this.personType = personType;
    this.idBranchOffice = idBranchOffice;
    this.idMovement = idMovement;
    this.validationMode = validationMode;
  }
}
